import {addThousandsSeparator, formatDecimalString} from "./numberUtils";
import {sanitizeString} from "./stringUtils";


/**
 * Formats a number (or numeric string) by inserting thousands separators (commas).
 *
 * @param value - The value to format; converted to a string before formatting.
 * @returns The value as a string with commas inserted every three digits.
 */
export const numberFormatter = (value: any) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * Creates a formatter function that limits the decimal portion of a numeric string to a fixed number of digits and adds thousands separators.
 *
 * @param decimalLimit - Maximum number of digits allowed after the decimal point.
 * @returns A formatter function that takes a value and returns it sanitized, decimal-limited, and thousands-separated.
 */
export const numberFormatterWithDecimalLimit = (decimalLimit: number) => (value: any) => {
    if (value === undefined || value === null) return '';
    const [integerPart, decimalPart] = value.toString().split('.');
    const formattedDecimalPart = formatDecimalString(decimalLimit, decimalPart);
    const returnString = sanitizeString(`${integerPart}${formattedDecimalPart}`);
    const formattedReturnString = addThousandsSeparator(returnString);
    return formattedReturnString;
};

/**
 * Converts a plain object into a FormData instance by appending each property as a form field.
 *
 * @param payload - Plain object whose own enumerable properties will be appended to the FormData.
 * @returns A FormData instance populated with each property of the payload.
 */
export const createFormDataObject = (payload: any) => {
    const formData = new FormData();
    for (const property in payload) {
        formData.append(property, payload[property as keyof typeof payload]);
    }
    return formData;
};
